import { render, staticRenderFns } from "./WebPartHotProductsRunner.vue?vue&type=template&id=20e4d05e&scoped=true&"
import script from "./WebPartHotProductsRunner.vue?vue&type=script&lang=js&"
export * from "./WebPartHotProductsRunner.vue?vue&type=script&lang=js&"
import style0 from "./WebPartHotProductsRunner.vue?vue&type=style&index=0&id=20e4d05e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e4d05e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20e4d05e')) {
      api.createRecord('20e4d05e', component.options)
    } else {
      api.reload('20e4d05e', component.options)
    }
    module.hot.accept("./WebPartHotProductsRunner.vue?vue&type=template&id=20e4d05e&scoped=true&", function () {
      api.rerender('20e4d05e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/featureOnePage/webParts/WebPartHotProductsRunner.vue"
export default component.exports